module.exports = __webpack_public_path__ + "img/1F62A.f71b76f5.svg";